import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://www.dashlyx.com/IFJ/api/", 
  headers: {
    "content-type": "application/json",
    "Accept": "application/json",
  },
  withCredentials: false, 
});

export default axiosInstance;